export default class tccf7Complete {
  constructor( args ) {
    this.base             = args.base;

    this.elem             = this.base.elem;
    this.form             = this.base.form;
    this.error            = this.base.error;
    this.json             = args.json;
    this.thanksUrl        = this.json.send.complete_page || '#';
    this.start            = false;
    this.initComplete();
  }
  initComplete() {
    if(this.json.send === false){
      return;
    }
    const currentDomain = window.location.origin;
    const thanksDomain = new URL(this.thanksUrl, currentDomain).origin;
    if(currentDomain === thanksDomain){
      this.start = true;
      this.Complete();
    }
  }
  Complete() {
    const url = this.thanksUrl;
    document.addEventListener( 'wpcf7mailsent', function( event ) {
      location.href = url;
    }, false );
  }
}